module.exports = __webpack_public_path__ + "media/top/bubble_3-a207426d.svg";